import { useState } from 'react';
import VendorSelect from '@/components/VendorSelect';
import { Pencil } from 'lucide-react';

/**
 * Click-to-edit vendor field that swaps to a controlled VendorSelect dropdown.
 * Use anywhere a vendor name needs inline editing (agencies, snag list, etc.).
 */
export default function InlineVendorEdit({
  value,
  onSave,
  placeholder = 'Click to set vendor',
  className = '',
  testId
}) {
  const [editing, setEditing] = useState(false);

  if (editing) {
    return (
      <div className="min-w-[200px]" data-testid={testId ? `${testId}-editing` : undefined}>
        <VendorSelect
          value={value}
          onChange={(name, vendor) => { onSave(name, vendor); setEditing(false); }}
          autoFocus
          testId={testId ? `${testId}-select` : 'inline-vendor'}
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setEditing(true)}
      className={`cursor-pointer inline-flex items-center gap-1 group hover:text-[#3A8C8C] transition-colors ${className}`}
      data-testid={testId}
      title="Click to change vendor"
    >
      <span className={!value ? 'text-[#D4D0C8] italic' : ''}>{value || placeholder}</span>
      <Pencil size={11} strokeWidth={1.5} className="opacity-0 group-hover:opacity-60 text-[#3A8C8C] transition-opacity" />
    </button>
  );
}
